module.exports = __webpack_public_path__ + "static/media/Rectangle 75.37965659.png";